var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNzStrategyCollapseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18V17.893C10 17.098 9.504 16.405 8.883 15.909C8.07246 15.2626 7.48289 14.3802 7.1959 13.384C6.90891 12.3878 6.93868 11.327 7.28109 10.3485C7.62351 9.36991 8.26164 8.52199 9.10716 7.92207C9.95268 7.32215 10.9638 6.99988 12.0005 6.99988C13.0372 6.99988 14.0483 7.32215 14.8938 7.92207C15.7394 8.52199 16.3775 9.36991 16.7199 10.3485C17.0623 11.327 17.0921 12.3878 16.8051 13.384C16.5181 14.3802 15.9285 15.2626 15.118 15.909C14.496 16.406 14 17.098 14 17.893V18M10 18V20C10 20.2652 10.1054 20.5196 10.2929 20.7071C10.4804 20.8946 10.7348 21 11 21H13C13.2652 21 13.5196 20.8946 13.7071 20.7071C13.8946 20.5196 14 20.2652 14 20V18M10 18H14M20 12H21M4 12H3M12 4V3M17.657 6.343L18.364 5.636M6.344 6.343L5.636 5.636M12 15V13",
    stroke: "#435B37",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNzStrategyCollapseIcon);
export default __webpack_public_path__ + "static/media/NZStrategyCollapseIcon.ae138d2c5a3641e404e08c80c033c2cf.svg";
export { ForwardRef as ReactComponent };